import Api from "../constants/api";
import Url from "../constants/urls";
import history from "helper/history";
import LoginStore from "../stores/loginstore";
import * as LoginAction from "../actions/loginaction";
import dispatcher from "../dispatchers/dispatcher";
import DefaultAutoContainerStore from "../stores/defaultAutoContainerStore";

module.exports = {
    _preLoginApi: function(query) {
        dispatcher.dispatch({
            type: "LOGIN_LOADER",
            loader: true
        });
        Api._callAPI(Url.PRELOGIN_FETCH, "GET", query, (type, dt) => {
            if (type == "success") {
                let data = dt.res_data;
                if (data.status == 0) {
                    //Save the encryption key in Store
                    if (data.public_key) {
                        dispatcher.dispatch({
                            type: "SET_ENCRYPTION_KEY",
                            value: {
                                public_key: data.public_key,
                                token_id: data.token_id
                            }
                        });
                    }
                    const pageName = "/login/passwordpage";
                    history.push(pageName);
                } else if (data.status == 1) {
                    const pageName = "/login/mobileverificationpage";
                    history.push(pageName);
                }
            } else {
                dispatcher.dispatch({
                    type: "SET_ANY_KEY",
                    key: "errorMsg",
                    value: Api._showErrorMsg(dt.status, dt.responseJSON || "")
                });
            }
            dispatcher.dispatch({
                type: "LOGIN_LOADER",
                loader: false
            });
        });
    },
    _loginApi: function(query, withOtp) {
        dispatcher.dispatch({
            type: "LOGIN_LOADER",
            loader: true
        });
        Api._callAPI(Url.LOGIN, "POST", query, (type, dt, headers) => {
            if (type === "success") {
                const data = dt.res_data;
                const redirectUrl = localStorage.getItem("redirectUrl");
                if (redirectUrl && redirectUrl.includes("/login/gmail")) {
                    // remove it from localstorage
                    sessionStorage.removeItem("hardware_id");
                    sessionStorage.removeItem("gmail-addon-info");
                    localStorage.removeItem("redirectUrl");
                }
                if (data.status == 0) {
                    const currentURL = sessionStorage.getItem("gmail-addon-info");
                    if (currentURL && currentURL.includes("login/gmail-addon")) {
                        const param = Api.parseURLParams(currentURL);
                        if (data) {
                            // localStorage.setItem("userId", "");
                            const hardwareId = sessionStorage.getItem("hardware_id");
                            const gmailRedirectURL = `${param.redirect_url[0]}&cid=${headers["happay-cid"]}&token=${headers["happay-token"]}&hardware_id=${hardwareId}`;
                            sessionStorage.removeItem("gmail-addon-info");
                            sessionStorage.removeItem("hardware_id");
                            window.location.href = gmailRedirectURL;
                            return;
                        }
                    }
                    Api._setKey("org_id", data.details.org_id);
                    Api._setKey("viewType", "Employee");
                    if (data && data.flexi && Array.isArray(data.flexi)) {
                        let flexiData = data.flexi || [];
                        let flexiObj = {};
                        flexiData.forEach(el => {
                            if (el.web_id || el.web_id === "0") {
                                flexiObj[el.web_id] = el; // storing as key value pair in local storage, key as a web_id & value as a object, so we can direcly access web_id.
                            }
                        });
                        localStorage.setItem("flexiElements", JSON.stringify(flexiObj));
                        dispatcher.dispatch({
                            type: "FLEXI_DATA",
                            value: data && data.flexi ? flexiObj : {}
                        });
                    }

                    if (data.details.has_role) {
                        Api._setKey("has_role", data.details.has_role);
                    } else {
                        Api._setKey("has_role", false);
                    }
                    if (data.reset_password_within === 0) {
                        Api._setKey("reset_password", data.reset_password_within);
                    } else {
                        Api._removeKey("reset_password");
                    }

                    if (data.password_repeat_after || data.password_repeat_after === 0) {
                        Api._setKey("repeat_password", data.password_repeat_after);
                    } else {
                        Api._removeKey("repeat_password");
                    }

                    let pageName = "/dashboard";

                    if (redirectUrl && !redirectUrl.match(/undefined/g)) {
                        pageName = redirectUrl;

                        if (redirectUrl.match(/genericworkflow/g) && data.details.has_role) {
                            Api._setKey("viewType", "Privileged");
                        } else if (
                            (redirectUrl.match(/expense/g) ||
                            redirectUrl.match(/dashboard/g) ||
                            redirectUrl.match(/profile/g) ||
                            redirectUrl.match(/walletcontrol/g)) && !redirectUrl.includes("/login")
                        ) {
                            // nothing to do as pageName is assigned with redirectUrl
                            // Only supported for addexpense page now. Once we have a map of privilege view urls then we wil remove this check
                        } else {
                            pageName = "/dashboard";
                        }
                    }

                    if (withOtp) pageName = "/profile/password";

                    /*below code is to check if the login is through the mail approval button or a 
                    normal login.if the login is happening thro, in mail approval button.will call 
                    the store method, to emit a change. to emit a change, I m not using dispatcher. 
                    becz I don't need to send any data to store.and it can produce a error for 
                    enabling dispatcher as dashboard page dispatcher will also be in use.if this is 
                    not the case of in mail approval . then earlier scenereo will be followed .
                    like pusing the hasHistory here only as "history.push(pageName)" . 
                    which is basically written in else part of the below logic.*/

                    let urlObj = DefaultAutoContainerStore._getUrlObj();
                    if (urlObj.hasOwnProperty("user") && urlObj.hasOwnProperty("userId")) {
                        if (urlObj.hasOwnProperty("hasRole") && urlObj.hasRole == "false") {
                            Api._setKey("viewType", "Employee");
                        } else {
                            Api._setKey("viewType", "Privileged");
                        }
                        LoginStore._handleEmitAutoDirect();
                    } else {
                        const searchParam = pageName.split("?")[1] || "";
                        const hasRole =
                            data.details.has_role && searchParam.search("hasRole=true") !== -1;
                        if (hasRole) {
                            Api._setKey("viewType", "Privileged");
                        }
                        history.push({
                            pathname: pageName.split("?")[0],
                            search: searchParam,
                            state: "login"
                        });
                    }
                } else if (data.status == 1) {
                    //Save the encryption key in Store
                    if (data.public_key) {
                        dispatcher.dispatch({
                            type: "SET_ENCRYPTION_KEY",
                            value: {
                                public_key: data.public_key,
                                token_id: data.token_id
                            }
                        });
                    }

                    LoginAction.setAnyKey("profiles", data.profiles);
                    let pageName = "/login/multiprofilepage";
                    history.push(pageName);
                } else if (data.status == 2) {
                    LoginAction.setAnyKey("details", data.details);
                    dispatcher.dispatch({
                        response: dt.res_data && dt.res_data.details,
                        type: "CARD_DETAILS"
                    });
                    if (data.details.is_mobile_verified == 1) {
                        let q = {
                            mobile_number: query.user,
                            otp: query.otp,
                            user_id: data.details.invite_id
                        };
                        this._validateOTPApi(q, data.details);
                    } else if (data.details.is_registred == 1) {
                        let pageName = "/login/registrationpage";
                        history.push(pageName);
                    } else if (data.details.is_email_verified == 1) {
                        const pageName = "/login/emailverificationpage";
                        history.push(pageName);
                    }
                } else if (data.status == 4) {
                    dispatcher.dispatch({
                        type: "SET_OTP",
                        key: "passOtp",
                        value: query.otp
                    });
                    Api._setKey("org_id", data.details.org_id);
                    Api._setKey("viewType", "Employee");
                    if (data.details.has_role) Api._setKey("has_role", data.details.has_role);
                    else Api._setKey("has_role", false);

                    if (redirectUrl && !redirectUrl.match(/undefined/g)) {
                        pageName = redirectUrl;
                        if (redirectUrl.match(/genericworkflow/g) && data.details.has_role) {
                            Api._setKey("viewType", "Privileged");
                        }
                    }
                    let pageName = "/login/setpassword";
                    history.push(pageName);
                }
            } else {
                dispatcher.dispatch({
                    type: "SET_ANY_KEY",
                    key: "errorMsg",
                    value: Api._showErrorMsg(dt.status, dt.responseJSON || "")
                });
                if (dt?.responseJSON?.is_expired) {
                    // Invalid token. push back to login page and clear the store
                    history.replace("/login");
                    dispatcher.dispatch({
                        type: "CLEAR_ALL"
                    });
                }
            }
            dispatcher.dispatch({
                type: "LOGIN_LOADER",
                loader: false
            });
        });
    },
    _sendOTPApi: function(query) {
        dispatcher.dispatch({
            type: "LOGIN_LOADER",
            loader: true
        });
        Api._callAPI(Url.PRELOGIN_SEND_OTP, "post", query, (type, dt) => {
            if (type == "success") {
                // dispatcher.dispatch({
                //     type: "SET_ANY_KEY",
                //     key: "errorMsg",
                //     value: dt.res_str
                // });
                // dispatcher.dispatch({
                //     type: "SNACKBAR",
                //     str: dt.res_str,
                //     toastType: 0
                // });
                dispatcher.dispatch({
                    type: "SET_ANY_KEY",
                    key: "otp",
                    value: true
                });
            } else {
                dispatcher.dispatch({
                    type: "SET_ANY_KEY",
                    key: "errorMsg",
                    value: Api._showErrorMsg(dt.status, dt.responseJSON || "")
                });
            }
            dispatcher.dispatch({
                type: "LOGIN_LOADER",
                loader: false
            });
        });
    },
    _validateOTPApi: function(query, details) {
        dispatcher.dispatch({
            type: "LOGIN_LOADER",
            loader: true
        });
        Api._callAPI(Url.PRELOGIN_VERIFY_OTP, "post", query, (type, dt) => {
            if (type == "success") {
                if (details.is_registred == 1) {
                    let pageName = "/login/registrationpage";
                    history.push(pageName);
                } else if (details.is_email_verified == 1) {
                    let pageName = "/login/emailverificationpage";
                    history.push(pageName);
                }
            } else {
                dispatcher.dispatch({
                    type: "SET_ANY_KEY",
                    key: "errorMsg",
                    value: Api._showErrorMsg(dt.status, dt.responseJSON || "")
                });
            }
            dispatcher.dispatch({
                type: "LOGIN_LOADER",
                loader: false
            });
        });
    },
    _verifyEmailApi: function(query, loader) {
        if (!dispatcher.isDispatching() && loader) {
            dispatcher.dispatch({ type: "LOGIN_LOADER", loader: true });
        }

        Api._callAPI(Url.PRELOGIN_VERIFY_EMAIL, "post", query, (type, dt) => {
            if (type == "success") {
                dispatcher.dispatch({
                    type: "SET_ANY_KEY",
                    key: "mailSent"
                    //value: 'Verification email sent to your email id',
                });
                if (loader) {
                    dispatcher.dispatch({
                        type: "SNACKBAR",
                        str: dt.res_str,
                        toastType: 0
                    });
                }
            } else {
                dispatcher.dispatch({
                    type: "SET_ANY_KEY",
                    key: "notSentMail"
                    //value: Api._showErrorMsg(dt.status,dt.responseJSON||''),
                });
            }
            if (loader) {
                dispatcher.dispatch({
                    type: "LOGIN_LOADER",
                    loader: false
                });
            }
            // if(loader)
            //     dispatcher.dispatch({type: 'LOGIN_LOADER',loader: false});
        });
    },
    _registrationAPI: function(query, is_super_user) {
        dispatcher.dispatch({
            type: "LOGIN_LOADER",
            loader: true
        });
        let apiUrl = is_super_user ? Url.PRELOGIN_CREATE_SUPER_USER : Url.PRELOGIN_CREATE_USER;
        Api._callAPI(apiUrl, "post", query, (type, dt) => {
            if (type == "success") {
                //let pageName = '/login/loginpage';
                let data = dt.res_data;
                if (data.sso == "true" || data.sso == true) {
                    Api._clearStorage();
                    history.replace("/login");
                } else {
                    let pageName = "/login/emailverificationpage";
                    history.push(pageName);
                }
                this._verifyEmailApi({ happay_id: data.happay_id });
                dispatcher.dispatch({
                    type: "HAPPAY_ID_KEY",
                    value: data
                });
            } else {
                dispatcher.dispatch({
                    type: "SET_ANY_KEY",
                    key: "errorMsg",
                    value: Api._showErrorMsg(dt.status, dt.responseJSON || "")
                });
            }
            dispatcher.dispatch({
                type: "LOGIN_LOADER",
                loader: false
            });
        });
    },
    _setPassword: function(query) {
        dispatcher.dispatch({
            type: "LOGIN_LOADER",
            loader: true
        });
        Api._callAPI(Url.CHANGE_PASSWORD, "post", query, (type, dt) => {
            if (type == "success") {
                let pageName = "/dashboard";
                history.push(pageName);
            } else {
                dispatcher.dispatch({
                    type: "SET_ANY_KEY",
                    key: "errorMsg",
                    value: Api._showErrorMsg(dt.status, dt.responseJSON || "")
                });
            }
            dispatcher.dispatch({
                type: "LOGIN_LOADER",
                loader: false
            });
        });
    },
    _checkSSO: function(query) {
        dispatcher.dispatch({
            type: "LOGIN_LOADER",
            loader: true
        });
        Api._callAPI(Url.SSO_CHECK, "get", query, (type, dt) => {
            if (type == "success") {
                window.location = dt.redirect_url;
            } else {
                dispatcher.dispatch({
                    type: "SET_ANY_KEY",
                    key: "errorMsg",
                    value: Api._showErrorMsg(dt.status, dt.responseJSON || "")
                });
            }
            dispatcher.dispatch({
                type: "LOGIN_LOADER",
                loader: false
            });
        });
    },
    _getCountryCodeTypeaheadAPI: function() {
        Api._callAPI(Url.COUNTRYCODE_TYPEAHEAD, "GET", "", (type, dt) => {
            if (type == "success") {
                dispatcher.dispatch({
                    type: "COUNTRY_CODE",
                    value: dt.res_data
                });
            } else {
                dispatcher.dispatch({
                    type: "SNACKBAR",
                    str: Api._showErrorMsg(dt.status, dt.responseJSON || "")
                });
            }
        });
    },
    _verifyEmailId: function(query, successCB = () => {}, failCB = () => {}) {
        console.log(111111);
        dispatcher.dispatch({ type: "LOGIN_LOADER", loader: true });
        Api._callAPI(Url.VERIFY_EMAIL_ID, "POST", query, (type, dt) => {
            if (type == "success") {
                successCB();
            } else {
                let msg = "Verification Link is Expired";
                if (dt.status == 400) {
                    var obj = dt.responseJSON;
                    if (obj.res_str) msg = obj.res_str;
                }
                failCB(msg);
            }
            dispatcher.dispatch({
                type: "LOGIN_LOADER",
                loader: false
            });
        });
    }
};
